import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as ContactService from '_services/contact-service';

const initialState = {
    contact: null,
    status: 'idle',
    error: null
};

// post a new message
export const postMessage = createAsyncThunk('contact/postMessage', async (contact) => {
    return ContactService.postContact(contact);
});

const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [postMessage.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [postMessage.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
            }
        },
        [postMessage.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = contactSlice.actions;
export const selectContact = state => state.contact.contact;
export const selectContactStatus = state => state.contact.status;
export const errorStatus = state => state.contact.error;
export default contactSlice.reducer;
